/* ══════════════════════════════════════════════════════════════════
   PRODUCT PAGE — gallery, quantity, optional-block visibility, and the
   unstick backstop. The page-turn carousel, the excerpt tabs, the bio
   link-ifier and the reveal are the AUTHOR PAGE's own code, spliced in
   below by scratchpad/assemble.py so the two pages behave identically.

   ⚠ On Shopify each block is its own theme section and this file runs
   once PER SECTION, so every initialiser guards against running twice.
   ══════════════════════════════════════════════════════════════════ */
(function () {
if (window.__twsPdpInit) return;
window.__twsPdpInit = true;

var $  = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

/* ── 1. gallery ─────────────────────────────────────────────────────
   The thumb strip is display:none until data-n is 2+. Liquid writes the
   real media count into data-n, so a single-image title (which is most
   of the catalogue) shows the cover alone with no orphan thumbnail. */
(function () {
  var main = $('#galMain'), strip = $('#galThumbs');
  if (!main || !strip) return;

  function show(i) {
    $$('.gal-pane', main).forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-i') === String(i)); });
    $$('.gal-th', strip).forEach(function (b) {
      var on = b.getAttribute('data-i') === String(i);
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  strip.addEventListener('click', function (e) {
    var b = e.target.closest('.gal-th'); if (!b) return;
    show(b.getAttribute('data-i'));
  });
  /* arrow keys walk the strip when it has focus — it is a real tablist */
  strip.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var vis = $$('.gal-th', strip).filter(function (b) { return !b.hidden; });
    var cur = vis.findIndex(function (b) { return b.classList.contains('on'); });
    var nxt = e.key === 'ArrowRight' ? (cur + 1) % vis.length : (cur - 1 + vis.length) % vis.length;
    show(vis[nxt].getAttribute('data-i')); vis[nxt].focus(); e.preventDefault();
  });
})();

/* ── 2. quantity ────────────────────────────────────────────────── */
(function () {
  var val = $('#qtyVal'), minus = $('#qtyMinus'), plus = $('#qtyPlus');
  if (!val) return;
  function set(n) { n = Math.max(1, Math.min(99, n)); val.textContent = String(n); }
  minus && minus.addEventListener('click', function () { set(parseInt(val.textContent, 10) - 1); });
  plus  && plus.addEventListener('click',  function () { set(parseInt(val.textContent, 10) + 1); });
})();

/* ── 3. optional blocks — empty means invisible, never an empty gap ──
   ⚠ THIS IS BELT AND BRACES, NOT THE MECHANISM. On Shopify the section
   is not rendered at all when its field is blank, which is the only way
   to guarantee no empty space. This pass exists so the LOCAL file behaves
   the same, and so a section that somehow renders empty still collapses
   rather than leaving a headed void. Each hero link dies with its
   section — a link to a section that is not there is worse than no link. */
(function () {
  function kill(sectionSel, linkSel, isEmpty) {
    var sec = $(sectionSel), link = linkSel ? $(linkSel) : null;
    /* ⚠ NO SECTION AT ALL IS THE COMMON CASE ON SHOPIFY, NOT AN ODD ONE.
       Each block is its own theme section and renders nothing when its field
       is blank, so #look / #excerpt are frequently absent from the DOM
       entirely. The original early return left the hero link pointing at an
       anchor that does not exist — a link that silently scrolls nowhere.
       An absent section must kill its link, not skip it. */
    if (!sec) { if (link) link.hidden = true; return; }
    if (isEmpty(sec)) { sec.hidden = true; if (link) link.hidden = true; }
    else if (link) link.hidden = false;
  }
  kill('#excerpt', '#readLink', function (s) {
    return !$$('.ap-rr-pane', s).some(function (p) { return (p.textContent || '').trim(); });
  });
  kill('#look', '#lookLink', function (s) {
    return $$('.ap-bk-src img', s).length === 0;
  });
  kill('#author', null, function (s) {
    var p = $('.ap-about-body p', s); return !p || !(p.textContent || '').trim();
  });
  /* the divider above the hero links has nothing left to divide */
  var sec = $('#pSec');
  if (sec && $$('a', sec).every(function (a) { return a.hidden; })) sec.hidden = true;
})();

/* ── 4. the unstick backstop ────────────────────────────────────────
   A backgrounded tab freezes document.timeline at 0, so `animation-fill:
   both` holds the FROM frame — opacity 0 — indefinitely. Strip the
   animation off anything still transparent after 1.6s. This is the fourth
   page where this family of bug has cost real time; it is never optional. */
(function () {
  var t = null;
  function unstick() {
    $$('[data-rv], .also-card, .pd-rule').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (parseFloat(cs.opacity) >= 0.99) return;
      el.style.animation = 'none';
      /* ⚠ CLEARING THE ANIMATION IS NOT ENOUGH ON THIS PAGE. tws-ap.js is
         loaded here too (the Excerpt / Look inside / About sections are the
         author page's own sections) and ITS reveal sets an INLINE
         opacity:0, then waits on an IntersectionObserver plus a
         requestAnimationFrame sweep. So two reveal systems own the same
         [data-rv] elements, and if both of the other one's routes stall the
         element is stranded at inline opacity 0 — which `animation:none`
         cannot undo. Clear the inline value as well. Harmless when the other
         script is working; the only rescue when it is not. */
      if (el.style.opacity !== '' && parseFloat(el.style.opacity) < 0.99) {
        el.style.opacity = '';
        el.style.transform = 'none';
      }
    });
  }
  function arm() { if (t) clearTimeout(t); t = setTimeout(unstick, 1600); }
  arm();
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') arm(); });
  addEventListener('pageshow', arm);
})();


/* ── 6. Details block — HERO ONLY, at every width (user's call, 4 Aug).
   It used to hop out to a column beside the description above 1080px. That
   move is gone: the four facts belong with the buy decision, not after a
   scroll, and a node that never moves cannot land in the wrong place when a
   breakpoint event fails to fire — which is exactly what happened on mobile
   the first time round. The markup already places it in the hero, so there
   is nothing left for this file to do. */



/* ── 7. the format chooser ──────────────────────────────────────────
   Swaps the hidden variant id, the price and the compare-at. Rendered only
   when the product has more than one variant, so this whole block no-ops on
   the ~75 single-variant titles. */
(function () {
  var row = $('.p-fmt-row'), hid = $('#pdpVariantId');
  if (!row || !hid) return;
  var price = $('#pdpPrice'), add = $('#addBtn');
  row.addEventListener('click', function (e) {
    var b = e.target.closest('.p-fmt-opt');
    if (!b || b.disabled) return;
    $$('.p-fmt-opt', row).forEach(function (o) {
      var on = o === b;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    hid.value = b.getAttribute('data-vid');
    if (price) price.textContent = b.getAttribute('data-price') || price.textContent;
    var was = b.getAttribute('data-was'), s = $('#pdpWas');
    if (s) { s.textContent = was || ''; s.hidden = !was; }
    var avail = b.getAttribute('data-available') === 'true';
    if (add) { add.disabled = !avail; add.textContent = avail ? 'Add to cart' : 'Sold out'; }
  });
})();

/* ── 8. quantity -> the form ────────────────────────────────────────
   The visible counter is a pair of buttons and a <span>; the form needs a
   real input. Mirror the span into it on every change, and once more at
   submit so a value can never be stale. */
(function () {
  var val = $('#qtyVal'), inp = $('#pdpQty'), form = $('#pdpForm');
  if (!val || !inp) return;
  function sync() { inp.value = val.textContent.trim() || '1'; }
  new MutationObserver(sync).observe(val, { childList: true, characterData: true, subtree: true });
  if (form) form.addEventListener('submit', sync);
  sync();
})();

/* ── 9. related products ────────────────────────────────────────────
   The band is ALREADY server-rendered with genre-matched titles, so this is
   an upgrade, not the mechanism: if Shopify's recommendations come back with
   something, swap them in; if the fetch fails, the reader keeps the cards
   that were always there. */
(function () {
  var grid = $('#pdpAlso');
  if (!grid || !grid.dataset.url) return;
  var done = false;
  function load() {
    if (done) return;
    done = true;
    fetch(grid.dataset.url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        var fresh = box.querySelector('#pdpAlso');
        if (fresh && fresh.children.length) grid.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* the fallback cards stay — nothing to do */ });
  }
  if (!('IntersectionObserver' in window)) return load();
  var io = new IntersectionObserver(function (es) {
    if (es[0].isIntersecting) { io.disconnect(); load(); }
  }, { rootMargin: '0px 0px 400px 0px' });
  io.observe(grid);
})();

})();
